import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Selector from 'react-select';
import { DropdownIndicator } from '~/Styles/reactSelectStyles';
import { selectStyles } from './selectStyles';

export default function SelectHierarquiaComercial({
  grupoEmpresas,
  hierarquia,
  filtros,
  onFiltroChange,
}) {
  const opcoesGEVendedor = (grupoEmpresas || []).map(g => ({
    value: g.codigo_grupo_empresa,
    label: g.apelido,
  }));

  const opcoesGerentes = (hierarquia.gerentes || []).map(h => ({
    value: h.codigo_conta,
    label: h.apelido_conta,
  }));

  const opcoesSupervisores = (hierarquia.supervisores || []).map(h => ({
    value: h.codigo_conta,
    label: h.apelido_conta,
  }));

  const opcoesAssessores = (hierarquia.assessores || []).map(h => ({
    value: h.codigo_conta,
    label: h.apelido_conta,
  }));

  const opcoesCorretores = (hierarquia.corretores || []).map(h => ({
    value: h.codigo_conta,
    label: h.apelido_conta,
  }));

  const hierarquiaVisivel = !!filtros.codigo_ge_vendedor;

  return (
    <>
      <Row className="mb-2">
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>G.E. do Vendedor:</Form.Label>
            <Selector
              styles={selectStyles}
              components={{ DropdownIndicator }}
              options={opcoesGEVendedor}
              isClearable
              placeholder="Selecione o G.E...."
              value={opcoesGEVendedor.find(o => o.value === filtros.codigo_ge_vendedor) || null}
              onChange={opt => onFiltroChange('codigo_ge_vendedor', opt ? opt.value : null)}
              noOptionsMessage={() => 'Nenhum G.E. encontrado'}
            />
          </Form.Group>
        </Col>

        {hierarquiaVisivel && (
          <>
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>Gerente:</Form.Label>
                <Selector
                  styles={selectStyles}
                  components={{ DropdownIndicator }}
                  options={opcoesGerentes}
                  isClearable
                  placeholder="Todos os gerentes..."
                  value={opcoesGerentes.find(o => o.value === filtros.codigo_gerente) || null}
                  onChange={opt => onFiltroChange('codigo_gerente', opt ? opt.value : null)}
                  noOptionsMessage={() => 'Nenhum gerente encontrado'}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>Supervisor:</Form.Label>
                <Selector
                  styles={selectStyles}
                  components={{ DropdownIndicator }}
                  options={opcoesSupervisores}
                  isClearable
                  placeholder="Todos os supervisores..."
                  value={opcoesSupervisores.find(o => o.value === filtros.codigo_supervisor) || null}
                  onChange={opt => onFiltroChange('codigo_supervisor', opt ? opt.value : null)}
                  noOptionsMessage={() => 'Selecione um Gerente primeiro'}
                  isDisabled={!filtros.codigo_gerente}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>Assessor:</Form.Label>
                <Selector
                  styles={selectStyles}
                  components={{ DropdownIndicator }}
                  options={opcoesAssessores}
                  isClearable
                  placeholder="Todos os assessores..."
                  value={opcoesAssessores.find(o => o.value === filtros.codigo_assessor) || null}
                  onChange={opt => onFiltroChange('codigo_assessor', opt ? opt.value : null)}
                  noOptionsMessage={() => 'Selecione um Supervisor primeiro'}
                  isDisabled={!filtros.codigo_supervisor}
                />
              </Form.Group>
            </Col>
          </>
        )}
      </Row>

      {hierarquiaVisivel && (
        <Row className="mb-2">
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Corretor:</Form.Label>
              <Selector
                styles={selectStyles}
                components={{ DropdownIndicator }}
                options={opcoesCorretores}
                isClearable
                placeholder="Todos os corretores..."
                value={opcoesCorretores.find(o => o.value === filtros.codigo_corretor) || null}
                onChange={opt => onFiltroChange('codigo_corretor', opt ? opt.value : null)}
                noOptionsMessage={() => 'Selecione um Assessor primeiro'}
                isDisabled={!filtros.codigo_assessor}
              />
            </Form.Group>
          </Col>
        </Row>
      )}
    </>
  );
}
